import logo from "../../assets/logo-header.png";
import MainStyle from "components/UI/main.module.scss";
//import styles from "./header.module.scss";


const Header = () => {
  return (
    <div className={[MainStyle.navbar, MainStyle.shadow_sm, MainStyle.border_bottom].join(" ")}>
      <div className={MainStyle.navbar_brand}>
        <div className={MainStyle.row}>
          <div className={MainStyle.col_12}>
            <div className={[MainStyle.py_3, MainStyle.ty_3].join(" ")}>
              <div className={[MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                <img src={logo} alt="Logo ISE" className={MainStyle.navbar_logo}></img>
              </div>
            </div>
          </div>
        </div>  
      </div>
    </div>
  );
};

export default Header;
